import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from "@/store/index.js";
import router from "@/router";
import * as tools from "@/utils/tools";
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$tools = tools;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
